import React, { useContext } from "react";
import PropTypes from "prop-types";
import { SimpleContext } from "../../../../../../store/context/simple-context";
import "./index.scss";

const Billed = ({ price, cents }) => {
  const {
    translate: { t },
  } = useContext(SimpleContext);

  return (
    <p className="GP-C-SB-T-B">
      {`$${price.toLocaleString(t("language code"))}`}
      {cents && <sup>{cents}</sup>}
      <span className="GP-C-SB-T-B__period">{t("billed yearly")}</span>
    </p>
  );
};

Billed.propTypes = {
  price: PropTypes.number,
  cents: PropTypes.number,
};

export default Billed;
